export const FEATURE_FLAGS = {
  AGENT_BOTS: 'agent_bots',
  AGENT_MANAGEMENT: 'agent_management',
  AUTO_RESOLVE_CONVERSATIONS: 'auto_resolve_conversations',
  AUTOMATIONS: 'automations',
  CAMPAIGNS: 'campaigns',
  CANNED_RESPONSES: 'canned_responses',
  CRM: 'crm',
  CUSTOM_ATTRIBUTES: 'custom_attributes',
  INBOX_MANAGEMENT: 'inbox_management',
  INTEGRATIONS: 'integrations',
  LABELS: 'labels',
  MACROS: 'macros',
  HELP_CENTER: 'help_center',
  REPORTS: 'reports',
  TEAM_MANAGEMENT: 'team_management',
  VOICE_RECORDER: 'voice_recorder',
  AUDIT_LOGS: 'audit_logs',
  SLA: 'sla',
  RESPONSE_BOT: 'response_bot',
  CHANNEL_EMAIL: 'channel_email',
  CHANNEL_FACEBOOK: 'channel_facebook',
  CHANNEL_TWITTER: 'channel_twitter',
  CHANNEL_WEBSITE: 'channel_website',
  CHANNEL_API: 'channel_api',
  CHANNEL_WHATSAPP: 'channel_whatsapp',
  CHANNEL_SMS: 'channel_sms',
  CHANNEL_TELEGRAM: 'channel_telegram',
  CHANNEL_LINE: 'channel_line',
  CHANNEL_ZALOOA: 'channel_zalooa',
  CHANNEL_ZALOPERSONAL: 'channel_zalopersonal',
  CUSTOM_REPLY_DOMAIN: 'custom_reply_domain',
  CUSTOM_REPLY_EMAIL: 'custom_reply_email',
  DISABLE_BRANDING: 'disable_branding',
  EMAIL_CONTINUITY_ON_API_CHANNEL: 'email_continuity_on_api_channel',
  INBOUND_EMAILS: 'inbound_emails',
   CONTACT_DISCOVERY: 'contact_discovery',
  IP_LOOKUP: 'ip_lookup',
  LINEAR: 'linear_integration',
  CUSTOM_ROLES: 'custom_roles',
  // AI Features
  AI_CORE: 'ai_core',
  AI_CONFIGURATION: 'ai_configuration',
  AI_BUSINESS_DATA: 'ai_business_data',
  AI_FILE_SOURCES: 'ai_file_sources',
  AI_WEB_IMPORTER: 'ai_web_importer',
  AI_DATA_COLLECTION: 'ai_data_collection',
  AI_GOOGLE_SHEETS_SYNC: 'ai_google_sheets_sync',
  AI_IMAGE_LIBRARY: 'ai_image_library',
  AI_CONVERSATION_SUMMARY: 'ai_conversation_summary',
};
